var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.id)?_c('v-card',{attrs:{"height":"100%"}},[_c('v-card-text',[_vm._v(" Bienvenido "+_vm._s(_vm.user.nombre)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }